import React from "react";
import ApexCharts from "react-apexcharts";

export default function QualityTotalStackedBar({ data }) {


  //  const  data= [
  //     {"month_name":"April","month_key":"2025-04","fitem_code":"1260","fitem_desc":"MARBAL EM (1260)","prod_meter":1049.0,"total_weight":0.0,"yarn_cost":0.0,"fix_cost":5,"total_cost":5000.0,"sale_value":6000.0,"diff_value":1000.0},
  //     {"month_name":"April","month_key":"2025-04","fitem_code":"1323B","fitem_desc":"OSCAR BUTTA(B)","prod_meter":18148.0,"total_weight":0.0,"yarn_cost":0.0,"fix_cost":5,"total_cost":8000.0,"sale_value":10000.0,"diff_value":2000.0},
  //     {"month_name":"April","month_key":"2025-04","fitem_code":"1323D","fitem_desc":"LIRIL BUTTA(D)","prod_meter":18935.0,"total_weight":0.0,"yarn_cost":0.0,"fix_cost":5,"total_cost":7000.0,"sale_value":8500.0,"diff_value":1500.0},
  //     {"month_name":"May","month_key":"2025-05","fitem_code":"1260","fitem_desc":"MARBAL EM (1260)","prod_meter":1200.0,"total_weight":0.0,"yarn_cost":0.0,"fix_cost":5,"total_cost":6000.0,"sale_value":7000.0,"diff_value":1000.0},
  //     {"month_name":"May","month_key":"2025-05","fitem_code":"1323B","fitem_desc":"OSCAR BUTTA(B)","prod_meter":19000.0,"total_weight":0.0,"yarn_cost":0.0,"fix_cost":5,"total_cost":8500.0,"sale_value":10500.0,"diff_value":2000.0},
  //     {"month_name":"May","month_key":"2025-05","fitem_code":"1323D","fitem_desc":"LIRIL BUTTA(D)","prod_meter":20000.0,"total_weight":0.0,"yarn_cost":0.0,"fix_cost":5,"total_cost":7500.0,"sale_value":9000.0,"diff_value":1500.0},
  //     {"month_name":"June","month_key":"2025-06","fitem_code":"1260","fitem_desc":"MARBAL EM (1260)","prod_meter":1100.0,"total_weight":0.0,"yarn_cost":0.0,"fix_cost":5,"total_cost":5500.0,"sale_value":6500.0,"diff_value":1000.0},
  //     {"month_name":"June","month_key":"2025-06","fitem_code":"1323B","fitem_desc":"OSCAR BUTTA(B)","prod_meter":18500.0,"total_weight":0.0,"yarn_cost":0.0,"fix_cost":5,"total_cost":8200.0,"sale_value":10200.0,"diff_value":2000.0},
  //     {"month_name":"June","month_key":"2025-06","fitem_code":"1323D","fitem_desc":"LIRIL BUTTA(D)","prod_meter":19500.0,"total_weight":0.0,"yarn_cost":0.0,"fix_cost":5,"total_cost":7200.0,"sale_value":8700.0,"diff_value":1500.0}
  //   ]



  // Get unique qualities
  const qualities = [...new Set(data.map(d => d.fitem_desc))];

  // Aggregate totals per quality across all months
  const totalPerQuality = qualities.map(qty => {
    const filtered = data.filter(d => d.fitem_desc === qty);
    const total_cost = filtered.reduce((sum, d) => sum + d.total_cost, 0);
    const sale_value = filtered.reduce((sum, d) => sum + d.sale_value, 0);
    const diff_value = filtered.reduce((sum, d) => sum + d.diff_value, 0);
    return { fitem_desc: qty, total_cost, sale_value, diff_value };
  });

  // Build series
  const series = [
    { name: "Cost", data: totalPerQuality.map(d => d.total_cost) },
    { name: "Sale", data: totalPerQuality.map(d => d.sale_value) },
    { name: "Diff", data: totalPerQuality.map(d => d.diff_value) }
  ];

  const chartOptions = {
    chart: {
      type: "bar",
      stacked: true,
      toolbar: { show: true }
    },
    plotOptions: {
      bar: { horizontal: false, columnWidth: "60%" }
    },
    dataLabels: {
    enabled: false // <-- disable values on bars
  },
    xaxis: { categories: qualities, title: { text: "Quality" } },
    yaxis: {
      title: { text: "Amount" },
      labels: {
        formatter: val => (val).toFixed(2) // optional rounding
      }
    },
    legend: { position: "top", fontSize: "14px" }
  };

  return (
    <ApexCharts
      options={chartOptions}
      series={series}
      type="bar"
      height={550}
    />
  );
}
